import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Tooltip } from 'reactstrap';
import * as types from "../../constants/actionTypes";
import GenericInput from "../common/input/GenericInput";
import SectionLoadingError from '../common/SectionLoadingError';
import DataComponent from "../common/DataComponent";
import LoginSettingsUserName from "./LoginSettingsUserName";
import LoginSettingsPassword from "./LoginSettingsPassword";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import { PageHeading } from "../ecosystem/mybswh";


class LoginSettings extends DataComponent {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        if (super.componentDidMount) { super.componentDidMount(); }
        logUI("MBHWeb.UI.LoginSettings.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        this.props.refreshLoginSettings();
    }


  


    validateConfirm(group,event) {
        const target = event.target;
        const value = !target ? event : target.type === 'checkbox' ? target.checked : target.value;
        const passwordData = this.state.passwordData;
        const errors = {};
        if (group === 'confirmPassword') {
            if (target) {
                errors["passwordMismatch"] = (value === this.state.passwordData.NewPassword) ? false : true;
            }
            if (value) {
                this.setState({ invalidInput: false });
            } else {
                this.setState({ invalidInput: true });
            }
        }
        if (group === 'confirmUsername') {
            if (target) {
                errors["userNameMismatch"] = (value === this.state.userNamesData.NewUserName) ? false : true;
            }
            if (value) {
                this.setState({ invalidInputName: false });
            } else {
                this.setState({ invalidInputName: true });
            }

        }
        this.setState(prevState => ({
            errors: {
                ...prevState.errors,
                passwordMismatch: errors["passwordMismatch"],
                userNameMismatch: errors["userNameMismatch"]
            }
        }));
    }



    render() {
                
        const { errors, passwordData, invalidInput, invalidInputName, editingUserName, editingPassword } = this.state;

        const { isLoggedIn, technicalHelpDeskNumber, userName } = this.props;
        
        return (
            <div className="container-fluid body-content login-settings-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="row">
                            <div className="col-12">
                                <PageHeading heading="Login Settings" />
                            </div>
                        </div>
                        <div className="row">
                            <LoginSettingsUserName />
                        </div>

                        <div className="row">
                            <LoginSettingsPassword />
                        </div>

                    </div>
                    
                </div>
               
            </div>
        );
    };
}

const mapStateToProps = (state) => {
    return {
        isLoggedIn: state.domain.li,
        userName: state.domain.un,
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : "",
        Email: state.domain.e,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        refreshLoginSettings: () => {
            dispatch({
                type: types.RESET_LOGIN_SETTINGS_DATA                
            });
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(LoginSettings);